const SELECTRORS = {
  swiperContainer: '.blog-header-swiper',
};
/**
 * Initialize swiper
 *
 * @param {object} Swiper swiper class object
 * @param {object} Pagination swiper pagination module
 */
const initBlogHeaderSlider = (Swiper, Pagination) => {
  const swiperContainer = document.querySelector(SELECTRORS.swiperContainer);
  const swiperOptions = {
    modules: [Pagination],
    slidesPerView: 'auto',
    spaceBetween: 10,
    watchOverflow: true,
    loop: false,
    breakpoints: {
      960: {
        spaceBetween: 0,
      },
    },
  };
  if (swiperContainer && Swiper) {
    // eslint-disable-next-line no-unused-vars
    const blogHeader = new Swiper(swiperContainer, swiperOptions);
  }
};

document.addEventListener('DOMContentLoaded', () => {
  window.LoadSwiper.then((module) => {
    initBlogHeaderSlider(module.Swiper, module.Pagination);
  });
});
